import { render, staticRenderFns } from "./rss.vue?vue&type=template&id=6ba83ed4&"
import script from "./rss.vue?vue&type=script&lang=js&"
export * from "./rss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports